import { createFormContext } from '@mantine/form';
import { ValidMessageFormValue } from '#/components/ui/messages/model/messageForm.ts';

const [
  MessageEditorFormProvider,
  useMessageEditorFormContext,
  useMessageEditorForm,
] = createFormContext<ValidMessageFormValue>();

export {
  MessageEditorFormProvider,
  useMessageEditorFormContext,
  useMessageEditorForm,
};
